<template>
  <div>

    <div class="d-flex justify-space-between mb-5">
      <div>
        <div class="page-title mb-2">
          รายงานความก้าวหน้าที่ยื่น สป.อว.
        </div>
        <div class="d-flex align-center font-type-bold txt-head black--text">
          <Iconify
              icon="ci:list-checklist"
              color="var(--theme-color-one)"
              class="mr-3"
          ></Iconify>
          รายงานความก้าวหน้าที่ยื่น สป.อว
        </div>
      </div>

      <div class="d-flex flex-column gap-12">
        <div class="d-flex gap-12">
<!--          <div class="flex-center" style="max-width: 190px">-->
<!--            <div>สถานะ</div>-->
<!--            <SelectBox-->
<!--                placeholder="สถานะ"-->
<!--                hide-details-->
<!--            ></SelectBox>-->
<!--          </div>-->

          <div style="max-width: 250px">
            <TextField
                hide-details
                placeholder="ค้นหา"
                append-inner-icon="search"
            ></TextField>
          </div>
        </div>

      </div>
    </div>

    <div>
      <div class="d-flex justify-space-between table-head">
        <div
            v-for="(item, i) in tableHeader"
            :key="i"
            :style="{ 'width': item.width }"
        >
          {{ item.name }}
        </div>
      </div>

      <div class="list-layout">
        <ProgressReportOfferItem
            v-for="(item, i) in formAList"
            :key="i"
            :item="item"
            :index="i"
            :headers="tableHeader"
        ></ProgressReportOfferItem>
      </div>
    </div>

  </div>
</template>

<script>
import TextField from "../../components/input/TextField"
import Button from "../../components/input/Button"
import SelectBox from "../../components/input/SelectBox"
import ProgressReportOfferItem from "../../components/ProgressReportOfferItem"

export default {
  name: "ProgressReportOfferList",
  components: {
    TextField,
    SelectBox,
    ProgressReportOfferItem,
    Button
  },
  data () {
    return {
      tableHeader: [
        {
          name: '',
          width: '6%'
        },
        {
          name: 'ลำดับ',
          width: '6%'
        },
        {
          name: 'ปี งปม.',
          width: '8%'
        },
        {
          name: 'ชื่อโครงการหลัก',
          width: '45%'
        },
        {
          name: 'ระยะเวลา',
          width: '12%'
        },
        {
          name: 'สถานะ',
          width: '11%'
        }
      ],
      formAList: []
    }
  },
  created () {
    this.getFormAList()
  },
  methods: {
    createProject () {
      this.$router.push({ name: 'MainProjectForm' })
    },
    async getFormAList () {
      let res
      res = await this.$apiFire('AForm/getFormAList', {
        doc_type: 'Progress,Final'
      })
      console.log(res)
      this.formAList = res
    }
  }
}
</script>

<style scoped>
.table-head {
  padding: 0 33px 0 36px;
  margin-bottom: 12px;
  gap: 8px;
}

.list-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>